export default __webpack_public_path__ + "static/media/fundo.a3354e9f.jpg";